import config from '@rivethealth/client/app/config';
import '@rivethealth/client/canny';
import '@rivethealth/client/gtag';
import '@rivethealth/client/intercom';
import { main } from '@rivethealth/client/main-common';

main(async () => (await import('./module')).AppModule, config);
